import { useEffect, useState } from "react";
import { Pagination, PaginationSectionWrapper } from "../../components/Pagination";
import { Loading } from "../../components/ui/loading";
import { ResourceLoadingError } from "../../components/ui/resource-loading-error";
import Workspace from "../../components/workspace";
import serviceReportService from "../../services/service-service";
import { ServiceReports } from "./service-reports";

const ServiceReportListContainer = ({ search = "", page, setPage }) => {
   const [serviceReports, setServiceReports] = useState([]);
   const [isLoading, setIsLoading] = useState(true);
   const [errorMessage, setErrorMessage] = useState();
   const [rows] = useState(10);
   const [totalPages, setTotalPages] = useState(1);

   useEffect(() => {
      async function loadServiceReports() {
         setIsLoading(true);
         try {
            const fetchResult = await serviceReportService.getServiceReports({ page, rows, search });
            setServiceReports(fetchResult.data);
            setTotalPages(fetchResult.totalPages);
         } catch (error) {
            setErrorMessage(error.message);
         } finally {
            setIsLoading(false);
         }
      }
      loadServiceReports();

      return () => {
         setErrorMessage(null);
      };
   }, [page, rows, search]);

   if (isLoading) return <Loading />;
   if (errorMessage) return <ResourceLoadingError error={errorMessage} />;

   return (
      <Workspace.List>
         <ServiceReports serviceReports={serviceReports} setServiceReports={setServiceReports} />
         <PaginationSectionWrapper>
            {serviceReports.length ? <Pagination setPage={setPage} page={page} totalPages={totalPages} /> : ""}
         </PaginationSectionWrapper>
      </Workspace.List>
   );
};

export { ServiceReportListContainer };
